<template>
    <div v-if="!hide"  class="form-network form-network-twitter">
         <details open>
            <summary>{{ $t('dash.post-creator.form.twitter.text-options') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="type-switch">
                     {{ $t('dash.post-creator.form.twitter.split-text') }}
                    <ComponentSwitch 
                        :value="draftInstance.form.networks.twitter.tweetSplitting ? draftInstance.form.networks.twitter.tweetSplitting.active : false" 
                        :onChange="handlerTweetSplitting" 
                        :id="'switch-settings-advanced-twitter-1'"
                    />
                </div>
            </div>      
        </details>
        <details v-if="draftInstance.form.urlsTextContentHistory.length && this.textContentLength + 23 <= this.maxCharactersText" open>
            <summary>
                {{ $t('dash.post-creator.form.link-preview') }}
                <i class="fa-solid fa-caret-down"></i>
            </summary>
            <div class="content-detail form-link">
                <div class="list-thubmmail">

                    <div class="thubmmail" v-for="(url) in this.draftInstance.form.urlsTextContentHistory" @click="()=>selectUrl(url.value)" :key="url.value">
                        <Checkbox :id="url.value" :prefixId="'thubmmail-'" 
                            :isChecked="(draftInstance.form.networks.twitter.snippet.link == url.value)" 
                            :isDisable="(draftInstance.form.networks.twitter.snippet.link == url.value)"
                            :add="selectUrl" 
                            :remove="()=>{}"
                        />
                        <SnippetNetwork :link="url.value"/>
                    </div>
                </div>
            </div>
            
        </details>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from '@/store/index.js';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '@/components/mixins/Bots.vue'
    import minxinPost from '@/components/mixins/Posts.vue'
    import Checkbox from '@/components/dash/utils/checkbox.vue'

    import { VueDraft } from '@mashupweb/draft-lib';
    export default {

        components: {
            ComponentSwitch,
            SnippetNetwork,
            Checkbox
        },
        mixins: [minxinBot,minxinPost],

        props: {
            hide : {
                type: Boolean,
                default: false
            },

            files:Object,
            maxCharactersText:Number,
            draftInstance: VueDraft
        },
        
        data() {
            return {
                inputModel:{
                    switchCustomSnippet: false,
                 
                },
                lastModeSelected : undefined
            }
        },
        
        created () {
            
        },

        methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            handlerTweetSplitting(state) {
                this.draftInstance.form.networks.twitter.tweetSplitting.active = state
            },

            selectUrl(url) {
                if (!this.draftInstance.form.networks.twitter.snippet) this.draftInstance.form.networks.twitter.snippet = {}
                this.draftInstance.form.networks.twitter.snippet.link = this.draftInstance.form.networks.twitter.snippet.link == url ? '' : url
            },

            verifUrlSelected() {
                if (this.textContentLength + 23 > this.maxCharactersText) {
                    this.selectUrl('')
                    return
                }
                if (this.draftInstance.form.urlsTextContentHistory.length) {
                    let linkSelect = this.draftInstance.form.networks.twitter?.snippet?.link ?? null
                    if ((linkSelect && !this.draftInstance.form.urlsTextContentHistory.includes(linkSelect))) {
                        this.selectUrl('')
                    }
                }else{
                    this.selectUrl('')
                }
             
            }
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
            textContentLength() {
                const twttr = require('twitter-text')
                
                return twttr.default.parseTweet(
                    this.draftInstance.form.textContent.replace(/\\n/g, '\n').replace(/@(\d{13})/g, (match, id) => {
                        const mention = this.draftInstance.form.mentions[id];
                        if (mention) {
                            return mention.mention && mention.mention.twitter ? `@${mention.mention.twitter.name || mention.mention.twitter.id}` : mention.textDefault;
                        }
                        return match;
                    })
                ).weightedLength
                
            }
        },

        watch: {

            'draftInstance.form.urlsTextContent.items'(newValue) {
                this.verifUrlSelected()
            },

            'draftInstance.form.urlsTextContentHistory.items'(newValue) {
                this.verifUrlSelected()
            },
            textContentLength: {
                immediate: true,
                handler(newValue, oldValue) {
                    this.verifUrlSelected()
                }
            }
        },

        beforeDestroy () {
        
        }
        
    }
</script>